import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listMagistrados:[],
  newMagistrado:[]
};
export const mutations = {
  GET_MAGISTRADOS({ context }, magistrados) {
    let magistrados_array = [];
    Object.entries(magistrados).forEach(([key, val]) => {
      val.ncompleto =  val.nombre + ' ' + val.primer_apellido + ' ' + val.segundo_apellido 
      magistrados_array.push(val)
    });
    return (state.listMagistrados = magistrados_array);
  },
  SAVE_MAGISTRADO({ context }, magistrado) {
    state.newMagistrado = Object.assign({}, magistrado);
  },
  EDIT_MAGISTRADO({ context }, dataUser) {
    state.dataUser = Object.assign({}, dataUser);
  },
};
export const actions = {
  GET_MAGISTRADOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_MAGISTRADOS", response.data.data.magistrados);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_MAGISTRADO({ commit }, magistrado) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(magistrado)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_MAGISTRADO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_MAGISTRADO({ commit }, dataUser) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataUser)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_MAGISTRADO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_USER({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_FOLIO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {//leer datos
  listMagistrados: state => state.listMagistrados,
  newMagistrado: state => state.newMagistrado
};
